import { PublicClientApplication } from "@azure/msal-browser";

// Load environment variables or use defaults
const getEnvironmentVariable = (key, defaultValue) => {
  // For production, use environment variables
  if (process.env[`REACT_APP_${key}`]) {
    return process.env[`REACT_APP_${key}`];
  }
  // For local development, use defaults
  return defaultValue;
};

/**
 * Configuration for Azure AD authentication
 */
export const msalConfig = {
  auth: {
    clientId: getEnvironmentVariable('MSAL_CLIENT_ID'),
    authority: getEnvironmentVariable('MSAL_AUTHORITY'),
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

/**
 * Scopes required for the application
 */
export const loginRequest = {
  scopes: ["User.Read", "User.ReadBasic.All"]
};

/**
 * API endpoint configuration
 */
export const apiConfig = {
  analyze: getEnvironmentVariable('API_ANALYZE_ENDPOINT'),
  baseUrl: getEnvironmentVariable('API_BASE_URL'),
};

/**
 * PowerBI configuration
 */
export const powerBIConfig = {
  reportId: getEnvironmentVariable('POWERBI_REPORT_ID'),
  ctid: getEnvironmentVariable('POWERBI_CTID'),
};

// Create the MSAL instance for use throughout the application
export const msalInstance = new PublicClientApplication(msalConfig);